import { render, staticRenderFns } from "./EditarContratoProveedorModal.vue?vue&type=template&id=16d5dc1f&"
import script from "./EditarContratoProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./EditarContratoProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('16d5dc1f', component.options)
    } else {
      api.reload('16d5dc1f', component.options)
    }
    module.hot.accept("./EditarContratoProveedorModal.vue?vue&type=template&id=16d5dc1f&", function () {
      api.rerender('16d5dc1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ContratoProveedor/EditarContratoProveedorModal.vue"
export default component.exports